/* DUCKHOE · talla obligatoria (13 oct 2026).
   El widget de Kaching trae marcada la primera talla (la 4) y quien no toca el desplegable compraba la 4 sin querer
   (24 % de los anillos pagados el 13 oct). Esto añade «Elige tu talla» a los desplegables de talla y no deja añadir
   al carrito hasta que la clienta elige una. Solo actúa en desplegables cuyas opciones son todas números (tallas). */
(function () {
  if (window.__tallaObligatoria) return;
  window.__tallaObligatoria = true;
  var PH = 'Elige tu talla';
  var elegidas = new WeakSet();
  var dV = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value');
  var dI = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'selectedIndex');
  var dS = Object.getOwnPropertyDescriptor(HTMLOptionElement.prototype, 'selected');
  // La elección de la clienta se marca en fase de captura, antes de que Kaching procese el cambio.
  document.addEventListener('change', function (e) {
    var s = e.target;
    if (s && s.__tallaPrep && dV.get.call(s)) {
      elegidas.add(s); s.style.outline = '';
      if (!pendientes().length) quitarAviso();
    }
  }, true);

  function esTalla(sel) {
    var v = [].slice.call(sel.options).map(function (o) { return o.value.trim(); }).filter(Boolean);
    return v.length > 2 && v.every(function (x) { return /^\d{1,2}$/.test(x); });
  }
  function prep(sel) {
    if (sel.__tallaPrep || !esTalla(sel)) return;
    sel.__tallaPrep = true;
    var o = document.createElement('option');
    o.value = ''; o.textContent = PH; o.disabled = true;
    sel.insertBefore(o, sel.firstChild);
    o.selected = true;
    // Kaching (Preact) vuelve a poner la talla 4 por código en cada repintado. Hasta que la clienta elija,
    // se ignoran esos cambios por código; lo que ella elige con el desplegable no pasa por aquí.
    Object.defineProperty(sel, 'value', { configurable: true,
      get: function () { return dV.get.call(this); },
      set: function (v) { if (elegidas.has(this) || v === '') dV.set.call(this, v); } });
    Object.defineProperty(sel, 'selectedIndex', { configurable: true,
      get: function () { return dI.get.call(this); },
      set: function (i) { if (elegidas.has(this) || i === 0) dI.set.call(this, i); } });
  }
  // Kaching también marca la opción directamente (option.selected = true): se bloquea igual hasta que ella elija.
  function blindar(sel) {
    [].forEach.call(sel.options, function (o) {
      if (o.__tallaOpt || o.value === '') return;
      o.__tallaOpt = true;
      Object.defineProperty(o, 'selected', { configurable: true,
        get: function () { return dS.get.call(this); },
        set: function (v) { if (!v || elegidas.has(sel)) dS.set.call(this, v); } });
    });
    if (!elegidas.has(sel) && dI.get.call(sel) !== 0) dI.set.call(sel, 0);
  }
  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
  function pendientes() {
    return [].slice.call(document.querySelectorAll('select')).filter(function (s) {
      return s.__tallaPrep && visible(s) && (!elegidas.has(s) || !s.value);
    });
  }
  function quitarAviso() { var m = document.getElementById('talla-aviso'); if (m) m.remove(); }
  function avisar(btn, faltan) {
    faltan.forEach(function (s) { s.style.outline = '2px solid #c0392b'; s.style.outlineOffset = '1px'; });
    if (!document.getElementById('talla-aviso')) {
      var m = document.createElement('p');
      m.id = 'talla-aviso'; m.setAttribute('role', 'alert');
      m.textContent = 'Elige tu talla antes de añadir al carrito.';
      m.style.cssText = 'color:#c0392b;font-size:14px;margin:8px 0;text-align:center;';
      btn.parentNode.insertBefore(m, btn);
    }
    faltan[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    try { faltan[0].focus(); } catch (e) {}
  }
  function bloquear(e) {
    var btn = e.type === 'submit' ? (e.target.querySelector('button[name="add"]') || e.target) : e.target.closest && e.target.closest('button[name="add"], .product-form__submit');
    if (!btn) return;
    if (e.type === 'submit' && !/\/cart\/add/.test(e.target.getAttribute('action') || '')) return;
    var faltan = pendientes();
    if (!faltan.length) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    avisar(btn, faltan);
  }
  document.addEventListener('click', bloquear, true);
  document.addEventListener('submit', bloquear, true);

  function barrer() { [].forEach.call(document.querySelectorAll('select'), function (s) { prep(s); if (s.__tallaPrep) blindar(s); }); }
  barrer();
  new MutationObserver(barrer).observe(document.documentElement, { childList: true, subtree: true });
})();
